// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table__3u9Xb","Table__table":"Table__table__1GNH7","Table__footer":"Table__footer__qXep8","Table__footerInner":"Table__footerInner__3QqN7"};